import { useEffect, useState, useRef } from "react";
import axios from "axios";
import EmojiPicker from "emoji-picker-react";

const API = "/api";
const token = () => localStorage.getItem("token");
const headers = () => ({ Authorization: "Bearer " + token() });

export default function Emojis() {
  const [emojis, setEmojis] = useState<any[]>([]);
  const [modal, setModal] = useState(false);
  const [editando, setEditando] = useState<any>(null);
  const [form, setForm] = useState({ emoji: "", nombre: "", orden: 0, tamano: "mediano" });
  const [imagenFile, setImagenFile] = useState<File|null>(null);
  const [imagenPreview, setImagenPreview] = useState("");
  const [confirmId, setConfirmId] = useState<number|null>(null);
  const [cargando, setCargando] = useState(false);
  const [toast, setToast] = useState("");
  const [mostrarPicker, setMostrarPicker] = useState(false);
  const imagenRef = useRef<HTMLInputElement>(null);

  const mostrarToast = (msg: string) => { setToast(msg); setTimeout(() => setToast(""), 3000); };

  const cargar = async () => {
    const r = await fetch(API + "/emojis/admin", { headers: headers() });
    setEmojis(await r.json());
  };

  useEffect(() => { cargar(); }, []);

  const abrirNuevo = () => {
    setEditando(null);
    setForm({ emoji: "", nombre: "", orden: 0, tamano: "mediano" });
    setImagenFile(null); setImagenPreview(""); setMostrarPicker(false);
    setModal(true);
  };

  const abrirEditar = (e: any) => {
    setEditando(e);
    setForm({ emoji: e.emoji||"", nombre: e.nombre||"", orden: e.orden||0, tamano: e.tamano||"mediano" });
    setImagenFile(null); setImagenPreview(e.imagen_url ? e.imagen_url : ""); setMostrarPicker(false);
    setModal(true);
  };

  const seleccionarImagen = (e: any) => {
    const file = e.target.files[0];
    if (file) { setImagenFile(file); setImagenPreview(URL.createObjectURL(file)); }
  };

  const guardar = async () => {
    setCargando(true);
    try {
      let emojiId = editando?.id;
      if (editando) {
        await axios.put(API + "/emojis/" + editando.id, form, { headers: headers() });
      } else {
        const res = await axios.post(API + "/emojis/", form, { headers: headers() });
        emojiId = res.data.id;
      }
      if (imagenFile && emojiId) {
        const fd = new FormData();
        fd.append("file", imagenFile);
        await axios.post(API + "/emojis/" + emojiId + "/imagen", fd, { headers: headers() });
      }
      await cargar();
      setModal(false);
      mostrarToast(editando ? "Icono actualizado" : "Icono agregado");
    } catch { mostrarToast("Error al guardar"); }
    setCargando(false);
  };

  const eliminar = async (id: number) => {
    await fetch(API + "/emojis/" + id, { method: "DELETE", headers: headers() });
    setConfirmId(null);
    await cargar();
    mostrarToast("Icono eliminado");
  };

  const tamanoH = (t: string) => t === "pequeno" ? "32px" : t === "grande" ? "64px" : "48px";
  const tamanoF = (t: string) => t === "pequeno" ? "24px" : t === "grande" ? "48px" : "36px";

  return (
    <div>
      {toast && (
        <div style={{position:"fixed",top:"24px",right:"24px",zIndex:9999,background:"#fff",border:"1px solid #e5e7eb",boxShadow:"0 10px 40px rgba(0,0,0,0.12)",borderRadius:"12px",padding:"12px 20px",fontSize:"14px",fontWeight:600,color:"#374151"}}>{toast}</div>
      )}

      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"24px",flexWrap:"wrap",gap:"12px"}}>
        <div>
          <h1 style={{fontFamily:"Montserrat,sans-serif",fontSize:"24px",fontWeight:900,color:"#0D47A1",margin:0}}>Banco de Iconos</h1>
          <p style={{color:"#6b7280",fontSize:"14px",marginTop:"4px"}}>Emojis e imagenes para las categorias</p>
        </div>
        <button onClick={abrirNuevo}
          style={{background:"#0D47A1",color:"#fff",border:"none",borderRadius:"12px",padding:"10px 20px",fontWeight:800,fontSize:"14px",cursor:"pointer",fontFamily:"Nunito,sans-serif"}}>
          + Agregar Icono
        </button>
      </div>

      <div style={{background:"#fff",borderRadius:"16px",boxShadow:"0 2px 12px rgba(0,0,0,0.06)",padding:"24px"}}>
        {emojis.length === 0 ? (
          <div style={{textAlign:"center",padding:"60px 0",color:"#9ca3af"}}>
            <div style={{fontSize:"48px",marginBottom:"12px"}}>😶</div>
            <div style={{fontWeight:600}}>No hay iconos en el banco</div>
          </div>
        ) : (
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(120px,1fr))",gap:"12px"}}>
            {emojis.map(e => (
              <div key={e.id} style={{border:"2px solid #e5e7eb",borderRadius:"12px",padding:"16px 8px",textAlign:"center",opacity:e.activo?1:0.4}}>
                <div style={{minHeight:"56px",display:"flex",alignItems:"center",justifyContent:"center",marginBottom:"8px"}}>
                  {e.imagen_url
                    ? <img src={e.imagen_url} alt={e.nombre} style={{height:tamanoH(e.tamano||"mediano"),objectFit:"contain"}}/>
                    : <span style={{fontSize:tamanoF(e.tamano||"mediano")}}>{e.emoji}</span>
                  }
                </div>
                <div style={{fontSize:"12px",fontWeight:600,color:"#374151",marginBottom:"2px",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.nombre||"—"}</div>
                <div style={{fontSize:"11px",color:"#9ca3af",marginBottom:"8px"}}>{e.tamano||"mediano"}</div>
                <div style={{display:"flex",gap:"4px",justifyContent:"center"}}>
                  <button onClick={() => abrirEditar(e)} style={{background:"#eff6ff",border:"none",borderRadius:"6px",padding:"4px 8px",cursor:"pointer",fontSize:"12px"}}>✏️</button>
                  <button onClick={() => setConfirmId(e.id)} style={{background:"#fef2f2",border:"none",borderRadius:"6px",padding:"4px 8px",cursor:"pointer",fontSize:"12px"}}>🗑️</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {confirmId !== null && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:50,padding:"16px"}}>
          <div style={{background:"#fff",borderRadius:"16px",padding:"32px",maxWidth:"360px",width:"100%",textAlign:"center"}}>
            <div style={{fontSize:"40px",marginBottom:"12px"}}>🗑️</div>
            <h3 style={{fontFamily:"Montserrat,sans-serif",fontWeight:800,marginBottom:"8px"}}>Eliminar icono?</h3>
            <p style={{color:"#6b7280",fontSize:"14px",marginBottom:"24px"}}>Esta accion no se puede deshacer.</p>
            <div style={{display:"flex",gap:"12px"}}>
              <button onClick={() => setConfirmId(null)} style={{flex:1,padding:"10px",borderRadius:"10px",border:"2px solid #e5e7eb",background:"#fff",cursor:"pointer",fontWeight:600}}>Cancelar</button>
              <button onClick={() => eliminar(confirmId)} style={{flex:1,padding:"10px",borderRadius:"10px",border:"none",background:"#ef4444",color:"#fff",cursor:"pointer",fontWeight:700}}>Si, eliminar</button>
            </div>
          </div>
        </div>
      )}

      {modal && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:40,padding:"16px"}}>
          <div style={{background:"#fff",borderRadius:"16px",width:"100%",maxWidth:"440px",maxHeight:"90vh",overflowY:"auto"}}>
            <div style={{padding:"20px 24px",borderBottom:"1px solid #e5e7eb"}}>
              <h2 style={{fontFamily:"Montserrat,sans-serif",fontWeight:800,color:"#0D47A1",margin:0}}>{editando ? "Editar Icono" : "Nuevo Icono"}</h2>
            </div>
            <div style={{padding:"24px",display:"flex",flexDirection:"column",gap:"16px"}}>

              <div>
                <label style={{display:"block",fontSize:"13px",fontWeight:700,color:"#374151",marginBottom:"6px"}}>Imagen personalizada (opcional)</label>
                <div onClick={() => imagenRef.current?.click()}
                  style={{border:"2px dashed #e5e7eb",borderRadius:"12px",padding:"16px",textAlign:"center",cursor:"pointer"}}>
                  {imagenPreview ? (
                    <img src={imagenPreview} alt="" style={{height:"64px",margin:"0 auto",objectFit:"contain",borderRadius:"8px"}}/>
                  ) : (
                    <div>
                      <div style={{fontSize:"24px",marginBottom:"4px"}}>🖼️</div>
                      <p style={{color:"#9ca3af",fontSize:"12px",margin:0}}>Clic para subir imagen</p>
                    </div>
                  )}
                </div>
                <input ref={imagenRef} type="file" accept="image/*" onChange={seleccionarImagen} style={{display:"none"}}/>
              </div>

              <div>
                <label style={{display:"block",fontSize:"13px",fontWeight:700,color:"#374151",marginBottom:"6px"}}>Emoji</label>
                <div style={{display:"flex",gap:"10px",alignItems:"center"}}>
                  <div style={{width:"52px",height:"52px",background:"#EFF6FF",borderRadius:"12px",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"28px",flexShrink:0,cursor:"pointer"}} onClick={() => setMostrarPicker(!mostrarPicker)}>
                    {form.emoji || "😀"}
                  </div>
                  <div style={{flex:1}}>
                    <input value={form.emoji} onChange={e=>setForm({...form, emoji: e.target.value})}
                      placeholder="Pega un emoji aqui"
                      style={{width:"100%",border:"2px solid #e5e7eb",borderRadius:"10px",padding:"10px",fontSize:"20px",textAlign:"center",boxSizing:"border-box",outline:"none"}}/>
                  </div>
                </div>
                <button onClick={() => setMostrarPicker(!mostrarPicker)}
                  style={{marginTop:"8px",background:"#EFF6FF",border:"none",borderRadius:"10px",padding:"8px 16px",fontSize:"13px",fontWeight:700,cursor:"pointer",color:"#0D47A1",width:"100%"}}>
                  {mostrarPicker ? "Cerrar selector" : "Abrir selector de emojis 😊"}
                </button>
                {mostrarPicker && (
                  <div style={{marginTop:"8px",borderRadius:"12px",overflow:"hidden",boxShadow:"0 4px 20px rgba(0,0,0,0.15)"}}>
                    <EmojiPicker
                      onEmojiClick={(emojiData) => {
                        setForm({...form, emoji: emojiData.emoji});
                        setMostrarPicker(false);
                      }}
                      width="100%"
                      height={350}
                      searchPlaceholder="Buscar emoji..."
                    />
                  </div>
                )}
              </div>

              <div>
                <label style={{display:"block",fontSize:"13px",fontWeight:700,color:"#374151",marginBottom:"6px"}}>Nombre</label>
                <input value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})}
                  placeholder="Ej: Herramientas"
                  style={{width:"100%",border:"2px solid #e5e7eb",borderRadius:"10px",padding:"10px",fontSize:"14px",boxSizing:"border-box",outline:"none",fontFamily:"Nunito,sans-serif"}}/>
              </div>

              <div>
                <label style={{display:"block",fontSize:"13px",fontWeight:700,color:"#374151",marginBottom:"8px"}}>Tamano</label>
                <div style={{display:"flex",gap:"8px"}}>
                  {["pequeno","mediano","grande"].map(t => (
                    <button key={t} onClick={() => setForm({...form, tamano: t})}
                      style={{flex:1,padding:"8px",borderRadius:"10px",fontSize:"12px",fontWeight:600,cursor:"pointer",border:form.tamano===t?"2px solid #0D47A1":"2px solid #e5e7eb",background:form.tamano===t?"#0D47A1":"#fff",color:form.tamano===t?"#fff":"#374151"}}>
                      {t === "pequeno" ? "Pequeno" : t === "mediano" ? "Mediano" : "Grande"}
                    </button>
                  ))}
                </div>
              </div>

              <div>
                <label style={{display:"block",fontSize:"13px",fontWeight:700,color:"#374151",marginBottom:"6px"}}>Orden</label>
                <input type="number" min="0" value={form.orden} onChange={e => setForm({...form, orden: Number(e.target.value)})}
                  style={{width:"100%",border:"2px solid #e5e7eb",borderRadius:"10px",padding:"10px",fontSize:"14px",boxSizing:"border-box",outline:"none"}}/>
              </div>
            </div>

            <div style={{padding:"16px 24px",borderTop:"1px solid #e5e7eb",display:"flex",gap:"12px",justifyContent:"flex-end"}}>
              <button onClick={() => setModal(false)} style={{padding:"10px 20px",borderRadius:"10px",border:"2px solid #e5e7eb",background:"#fff",cursor:"pointer",fontWeight:600,fontSize:"14px"}}>Cancelar</button>
              <button onClick={guardar} disabled={cargando}
                style={{padding:"10px 20px",borderRadius:"10px",border:"none",background:"#0D47A1",color:"#fff",cursor:"pointer",fontWeight:800,fontSize:"14px",fontFamily:"Nunito,sans-serif",opacity:cargando?0.6:1}}>
                {cargando ? "Guardando..." : editando ? "Guardar Cambios" : "Agregar"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}